Ext.define('SA.data.UserAttributeList', {
    extend: 'SA.data.UserItemList',

    ensureCached() {
        return SA.data.AttributesCache.getPromise(this.getIds());
    },

    getId(item) {
        if (typeof item === 'object') {
            return item.attribute || item.id;
        }

        return item;
    }
});

SA.data.RecentAttributes = new SA.data.UserAttributeList({
    limit: 1000,
    resource: 'user/recentAttributes'
});

SA.data.FavoriteAttributes = new SA.data.UserAttributeList({
    resource: 'user/favoriteAttributes',

    getToggleText(attribute) {
        if (!this.contains(attribute)) {
            return SA.localize('Add to Favorites');
        }

        return SA.localize('Remove from Favorites');
    }
});